import { Configuration } from "./configuration";

// The container entrypoint (docker-entrypoint.d/06_inline_configuration.sh) inlines the
// configuration into index.html under this id and deletes the standalone file, so deployed
// environments do not expose /configuration.json as a downloadable URL.
export const CONFIGURATION_ELEMENT_ID = "acm-configuration";

// Only used by `ng serve` and other builds where the file is still served as an asset.
export const CONFIGURATION_PATH = "/configuration.json";

export function readInlineConfiguration(doc: Document): Configuration | null {
    const contents = doc.getElementById(CONFIGURATION_ELEMENT_ID)?.textContent?.trim();
    if (!contents) {
        return null;
    }

    try {
        return JSON.parse(contents) as Configuration;
    } catch (error) {
        console.error("Unable to parse the inlined configuration", error);
        return null;
    }
}

export function loadConfiguration(doc: Document = document): Promise<Configuration> {
    const inlined = readInlineConfiguration(doc);
    if (inlined) {
        return Promise.resolve(inlined);
    }

    return fetch(CONFIGURATION_PATH).then((response) => response.json() as Promise<Configuration>);
}
